import { ObjectType } from "typescript";

export const confirmData: { [key: string]: string; } = {
  Deleted: "Do you really want to delete this campaign?",
  Pause: "Do you really want to pause this campaign?",
  Active: "Do you really want to activate this campaign?",
  Save: "Do you want to  save?"
};